export default __webpack_public_path__ + "static/media/seasketch-logo.c4d8745d.png";